import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

export const consts = createReqConsts('appointment-form', 'user-details');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'profiles',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const initialState = {
  ...rootState,
  data: null,
};

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case consts.SEND: {
      return {
        ...initialState,
        sending: true,
        data: null,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        sending: false,
        succeed: true,
        data: payload,
      };
    }

    case APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
    case APPOINTMENT_PROGRESS_TYPES.CLEAR:
    case consts.CLEAR: {
      return { ...initialState };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/user-details-req.js